<style scoped>
.el-tab-sty {
  padding-left: 15px;
  border-radius: 6px 6px 0 0;
}

.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.ipt-sty {
  width: 70% !important;
}
</style>
<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="back-color-fff el-tab-sty">
      <!-- @tab-click="handleClick" -->
      <el-tab-pane label="待审批" name="first">
        <div class="search-area" style="border-radius: 0 0 6px 6px; padding: 16px 16px 16px 0">
          <el-row :gutter="24">
            <el-col :span="7">
              <div class="search-area-div">月份：</div>
              <el-date-picker
                v-model="monthList"
                type="monthrange"
                class="ipt-sty"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="7">
              <div class="search-area-div">企业：</div>
              <el-select v-model="page.tenantGuid" placeholder="请选择" class="ipt-sty" filterable>
               <el-option 
                  v-for="item in tenantList"
                  :key="item.sendTenantGuid"
                  :label="item.sendTenantName"
                  :value="item.sendTenantGuid">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="5">
              <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
              <el-button size="medium" type="danger" @click="empty">清空</el-button>
            </el-col>
          </el-row>
        </div>
        <!-- <div class="button-area" style="padding-left: 0; padding-top: 0;margin-top: 0;">
                      <el-button size="medium" type="info" @click="add(1,'')">批量审批</el-button> 
                  </div> -->
        <div class="back-color-fff" style="padding: 16px 16px 16px 0">
          <el-table :data="tableData" border style="width: 100%" v-loading="tableLoadingFirst">
            <el-table-column label="序号" width="60" header-align="center" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
                <!-- {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}} -->
              </template>
            </el-table-column>
            <el-table-column prop="month" label="月份" header-align="center" align="center"></el-table-column>
            <el-table-column prop="batchNum" label="批次" header-align="center" align="center"></el-table-column>
            <el-table-column prop="tenantName" label="企业" header-align="center" align="center"></el-table-column>
            <el-table-column prop="totalAmount" label="推广费总额(元)" header-align="center" align="right">
              <template slot-scope="scope">{{ scope.row.totalAmount | numDigit | numFmt }}</template>
            </el-table-column>
            <el-table-column prop="approvalTime" label="到达时间" header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.approvalTime | getDate }}</template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <a class="txt-color" @click="toDetail(scope.row.guid)">审批详情</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          class="pt pb back-color-fff"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 30, 50]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
        </el-pagination>
      </el-tab-pane>

      <el-tab-pane label="已审批" name="second">
        <div class="search-area" style="border-radius: 0 0 6px 6px; padding: 16px 16px 16px 0">
          <el-row :gutter="24">
            <el-col :span="7">
              <div class="search-area-div">月份：</div>
              <el-date-picker
                v-model="monthList"
                type="monthrange"
                class="ipt-sty"
                range-separator="至"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="7">
              <div class="search-area-div">企业：</div>
              <el-select v-model="page.tenantGuid" placeholder="请选择" class="ipt-sty" filterable>
                 <el-option 
                  v-for="item in tenantList"
                  :key="item.sendTenantGuid"
                  :label="item.sendTenantName"
                  :value="item.sendTenantGuid">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="5">
              <el-button size="medium" type="info" @click="getInvitWaitapprovalList(true)">搜索</el-button>
              <el-button size="medium" type="danger" @click="empty">清空</el-button>
            </el-col>
          </el-row>
        </div>
        <!-- <div class="button-area" style="padding-left: 0;">
                <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1,'')">添加用户</el-button>
                <el-button size="medium" type="danger" @click="getDeleteData(1,'')">批量删除</el-button>
                <el-button plain size="medium">历史数据</el-button>
            </div> -->
        <div class="back-color-fff" style="padding: 16px 16px 16px 0">
          <el-table :data="tableData" border style="width: 100%" v-loading="tableLoadingSecond">
            <el-table-column label="序号" width="60" header-align="center" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
                <!-- {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}} -->
              </template>
            </el-table-column>
            <el-table-column prop="month" label="月份" header-align="center" align="center"></el-table-column>
            <el-table-column prop="batchNum" label="批次" header-align="center" align="center"></el-table-column>
            <el-table-column prop="tenantName" label="企业" header-align="center" align="center"></el-table-column>
            <el-table-column prop="totalAmount" label="推广费总额(元)" header-align="center" align="right">
              <template slot-scope="scope">{{ scope.row.totalAmount | numDigit | numFmt }}</template>
            </el-table-column>
            <el-table-column prop="noticeTime" label="到达时间" header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.noticeTime | getDate }}</template>
            </el-table-column>
            <el-table-column prop="approvalTime" label="审批时间" sortable header-align="center" align="center">
              <template slot-scope="scope">{{ scope.row.approvalTime | getDate }}</template>
            </el-table-column>
            <el-table-column prop="approvalState" label="审批结果" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="fontC-green" v-if="scope.row.approvalState == 'Y'">
                  {{ scope.row.approvalState | approvalState }}
                </div>
                <div class="fontC-red" v-if="scope.row.approvalState == 'R'">
                  {{ scope.row.approvalState | approvalState }}
                </div>
                <div v-if="scope.row.approvalState == 'N' || scope.row.approvalState == 'A'">
                  {{ scope.row.approvalState | approvalState }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <a class="txt-color" @click="toLink(scope.row.guid)">详情</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          class="pt pb back-color-fff"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 30, 50]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      monthList: [],
      tenantList: [],
      tenantGuid: '',

      activeName: 'first',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        startMonth: '',
        endMonth: '',
      },
      tableData: [],
      tableLoadingFirst: false,
      tableLoadingSecond: false,
    };
  },
  created() {
    // 列表
    this.getTenant();
  },
  methods: {
    empty() {
      let self = this;
      self.monthList = [];
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        startMonth: '',
        endMonth: '',
      };
        if(self.tenantList != null && self.tenantList.length > 0){
            self.page.tenantGuid = self.tenantList[0].sendTenantGuid;
          }
      if (this.activeName == 'first') {
        this.getData(true);
      } else {
        this.getInvitWaitapprovalList(true);
      }
    },
    getTenant() { 
      let self = this;
      let query = {
        isService:true,
        tenantGuid:localStorage.guid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
          if(self.tenantList != null && self.tenantList.length > 0){
            // self.page.tenantGuid = self.tenantList[0].sendTenantGuid;
            // self.page.tenantGuid = '3d3861e610cb40218d3ecf641147affd';//测试
            self.page.tenantGuid = '37a58d7a80ae11ebafd0fa163e4b37cf';//正式
          }
          self.getData(false);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleClick(tab, event) {
      this.empty();
      console.log(this.activeName);
      if (this.activeName == 'first') {
        this.getData(true);
      } else {
        this.getInvitWaitapprovalList(true);
      }
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      if (self.monthList && Array.isArray(self.monthList) && self.monthList.length > 0) {
        self.page.startMonth = self.$moment(self.monthList[0]).format('YYYYMM');
        self.page.endMonth = self.$moment(self.monthList[1]).format('YYYYMM');
      } else {
        self.page.startMonth = '';
        self.page.endMonth = '';
      }
      self.tableLoadingFirst = true;
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/performance/data/get-performance-waitapproval-list`,
          self.page,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableLoadingFirst = false;
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getInvitWaitapprovalList(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      if (self.monthList && Array.isArray(self.monthList) && self.monthList.length > 0) {
        self.page.startMonth = self.$moment(self.monthList[0]).format('YYYYMM');
        self.page.endMonth = self.$moment(self.monthList[1]).format('YYYYMM');
      } else {
        self.page.startMonth = '';
        self.page.endMonth = '';
      }
      self.tableLoadingSecond = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/performance/data/get-performance-approvaled-list`, self.page)
        .then((res) => {
          console.log(res);
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableLoadingSecond = false;
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    toDetail(guid) {
      this.$router.push({ path: '/performanceAuditing', query: { guid: guid } });
    },
    toLink(guid) {
      this.$router.push({ path: '/performanceAuditing', query: { guid: guid } });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      if (this.activeName == 'first') {
        this.getData();
      } else {
        this.getInvitWaitapprovalList();
      }
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      if (this.activeName == 'first') {
        this.getData();
      } else {
        this.getInvitWaitapprovalList();
      }
    },
  },
};
</script> 